// src/app/core/interceptors/error.interceptor.ts
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private static alertedAccountLocked = false;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const status = error?.status;
        const payload: any = (error as any)?.error;

        const serverKey = payload?.key ?? payload?.code ?? payload?.error ?? '';
        const serverMsg = payload?.message ?? payload?.msg ?? '';
        const raw = `${serverKey} ${serverMsg} ${JSON.stringify(payload ?? {})}`;

        const isAccountValid = String(raw).includes('ACCOUNT_VALID');
        if ((status === 401 || status === 403) && isAccountValid) {
          if (!ErrorInterceptor.alertedAccountLocked) {
            ErrorInterceptor.alertedAccountLocked = true;
            alert('Tài khoản của bạn đã bị khoá. Vui lòng liên hệ quản trị viên.');
          }
        }

        console.error('HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }
}
